module.exports = __webpack_public_path__ + "static/media/instagram.2408bb39.svg";